import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common';
import type { ProfileNavItem } from './profileNav';

export interface AccountNavProps {
  items: ProfileNavItem[];
  className?: string;
  onNavigate?: () => void;
}

export function AccountNav({ items, className, onNavigate }: AccountNavProps) {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');

  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  return (
    <nav
      aria-label={label('Account', 'Account')}
      className={cn('flex w-full flex-col gap-1', className)}
    >
      {items.map((item) => (
        <Link
          key={item.id}
          to={item.to}
          onClick={onNavigate}
          activeOptions={{ exact: true }}
          className="flex w-full items-center justify-center gap-2.5 rounded-md p-2.5 text-[13px] leading-normal"
          inactiveProps={{
            className: 'bg-bg-elevated font-normal text-text-primary',
          }}
          activeProps={{
            className: 'bg-action-primary font-bold text-text-on-action',
          }}
        >
          <Icon name={item.icon} size={20} className="shrink-0 text-current" />
          <span className="min-w-0 flex-1 text-left">{label(item.label, item.label)}</span>
        </Link>
      ))}
    </nav>
  );
}
